import React from 'react';

const Image = ({ src, alt }: { src: string; alt?: string }) => {
  return <img src={src || '/images/thumb.jpg'} alt={alt ?? 'image'} />;
};

export default Image;
